import React, { useState, useEffect, useRef  } from "react";
import { useCart } from "../context/CartContext";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { ubicacionesCR } from "../data/zonesCR";
import SelectAdAstra from "../components/OptionsSelect";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { createPortal } from "react-dom";

export default function Checkout() {
  const [provincias, setProvincias] = useState([]);
  const [cantones, setCantones] = useState([]);
  const [distritos, setDistritos] = useState([]);
  const infoClienteRef = useRef(null);
  const { cart, totalPrice, clearCart, updateQuantity, removeFromCart } = useCart();
  const navigate = useNavigate();  
  const [paymentMethod, setPaymentMethod] = useState("sinpe");
  const [USD_RATE, setUSD_RATE] = useState(540);

  // Obtener tipo de cambio
  useEffect(() => {
    const obtenerTipoCambio = async () => {
      try {
        const res = await fetch("https://open.er-api.com/v6/latest/CRC");
        const data = await res.json();
        const rate = data?.rates?.USD;
        console.log(data)
        console.log(rate)
        if (rate) setUSD_RATE(1 / rate);
      } catch (err) {
        console.warn("No se pudo actualizar tipo de cambio, usando valor por defecto");
      }
    };
    obtenerTipoCambio();
  }, []);

  useEffect(() => {
  setProvincias(Object.keys(ubicacionesCR));
  }, []);




  const totalItems = cart.reduce((acc, item) => acc + item.quantity, 0);

  // Regla 2: existe un pack 3 o pack 5
  const hasBigPack = cart.some(item => {
    // Caso si item.pack viene como un string (ej: "3 PACK")
    if (typeof item.pack === "string") {
      return item.pack.includes("3") || item.pack.includes("5");
    }

    // Caso si item.pack viene como número (1,3,5)
    return item.pack === 3 || item.pack === 5;
  });

// Regla final:
const shippingCost = (totalItems > 1 || hasBigPack) ? 0 : 2500;



  const subtotal = totalPrice;

    // Estado
const [promoCode, setPromoCode] = useState("");
const [promoApplied, setPromoApplied] = useState(false);

// Descuento
const promoDiscountRate = promoApplied ? 0.10 : 0;
const promoDiscountAmount = Math.ceil(subtotal * promoDiscountRate);
const subtotalAfterPromo = subtotal - promoDiscountAmount;
  const COMMISSION_RATE = 0.06;

  const applyCommission = paymentMethod === "card" || paymentMethod === "paypal";

  const totalWithoutCommission = subtotalAfterPromo + shippingCost;


  


  const totalWithCommission = applyCommission
    ? Math.ceil((totalWithoutCommission / (1 - COMMISSION_RATE)))
    : Math.ceil(totalWithoutCommission);

  const commissionAmount = Math.ceil((totalWithCommission - totalWithoutCommission));


  const orderUSD = ((totalWithCommission) / USD_RATE).toFixed(2);

  const [loading, setLoading] = useState(false);
 

  const [form, setForm] = useState({
    nombre: "",
    apellido: "",
    telefono: "",
    email: "",
    provincia: "",
    canton: "",
    distrito: "",
    direccion: "",
  });

  const [errors, setErrors] = useState({});

  // 🚫 Bloqueo si el carrito está vacío (después de todos los hooks)
if (cart.length === 0) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-6">

      <img 
        src="/adastraloader.png"
        className="w-20 opacity-80 mb-4"
        alt="AdAstra Logo"
      />

      <h2 className="text-2xl font-bold text-gray-800 mb-2">
        Tu carrito está vacío
      </h2>

      <p className="text-gray-600 text-center max-w-md mb-6">
        Agrega productos al carrito para continuar con el proceso de compra.
      </p>

      <button
        onClick={() => navigate("/")}
        className="px-6 py-3 bg-black text-white rounded-lg font-semibold hover:bg-[#d24e1e] transition"
      >
        Volver a la tienda
      </button>

    </div>
  );
}


const validateForm = () => {
  const newErrors = {};

  if (!form.nombre.trim()) newErrors.nombre = "El nombre es obligatorio";
  if (!form.apellido.trim()) newErrors.apellido = "El apellido es obligatorio";
  if (!form.telefono.trim()) newErrors.telefono = "El teléfono es obligatorio";
  if (!form.email.trim()) newErrors.email = "El correo es obligatorio";
  if (!form.provincia.trim()) newErrors.provincia = "La provincia es obligatoria";
  if (!form.canton.trim()) newErrors.canton = "El cantón es obligatorio";
  if (!form.distrito.trim()) newErrors.distrito = "El distrito es obligatorio";
  if (!form.direccion.trim()) newErrors.direccion = "La dirección exacta es obligatoria";

  setErrors(newErrors);

  if (Object.keys(newErrors).length > 0) {
    // 👇 Auto-scroll elegante al inicio del formulario
    infoClienteRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
    return false;
  }

  return true;
};



  const handleInput = (e) => {
  const { name, value } = e.target;
  setForm({ ...form, [name]: value });

  // limpiar error al escribir
  if (errors[name]) {
    setErrors({ ...errors, [name]: null });
  }
};


const guardedCreateOrder = (createOrderCallback) => {
  if (!validateForm()) {
    return Promise.reject(new Error("Formulario incompleto"));
  }
  return createOrderCallback();
};

const toastCheckoutError = (message) => {
  toast.custom(
    (t) =>
      createPortal(
        <div
          className="fixed inset-0 z-[99999] flex items-center justify-center"
          onClick={() => toast.dismiss(t.id)}  // 👈 CIERRA SI HACE CLICK EN CUALQUIER PARTE
        >
          {/* Fondo oscuro */}
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm"></div>

          {/* Modal */}
          <div
            className={`
              relative bg-white border border-orange-500 shadow-xl rounded-2xl
              w-[90%] max-w-md p-6 
              ${t.visible ? "animate-enter" : "animate-leave"}
            `}
            onClick={(e) => e.stopPropagation()} // 👈 evita que el click dentro del modal lo cierre
          >
            <div className="flex flex-col items-center">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-3 h-3 rounded-full bg-red-500 animate-pulse"></div>
                <h3 className="font-bold text-lg text-gray-900">Ocurrió un error al procesar tu pedido.</h3>
              </div>

              <p className="text-gray-700 text-center font-medium mb-6 leading-relaxed">
                {message}
              </p>

              <button
                className="w-full py-2.5 rounded-lg bg-black text-white font-semibold hover:bg-red-600 transition"
                onClick={() => toast.dismiss(t.id)}  // 👈 CIERRA CON BOTÓN
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>,
        document.body
      ),
    { duration: Infinity }
  );
};

const getPaymentUsed = (method) => {
  switch (method) {
    case "card":
      return "Tarjeta";
    case "paypal":
      return "PayPal";
    case "sinpe":
      return "SINPE Móvil";
    case "tb":
      return "Transferencia Bancaria";
  }
};



  const onPayPalSuccess = async (order) => {
    setLoading(true);
    try {
      if (order.status === 'COMPLETED')
      {
        const paymentUsed = getPaymentUsed(paymentMethod);

        const response = await fetch("https://beadastra-a7epexf5c5b7dng0.canadacentral-01.azurewebsites.net/orders/create", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            orderId : order.id,
            customerName: form.nombre + ' ' + form.apellido,
            customerEmail: form.email,
            customerPhone: form.telefono,
            paymentMethod: paymentUsed,
            paypalJson: JSON.stringify(order),
            amount: totalWithCommission,
            amountUSD: orderUSD,
            stateId:form.provincia,
            cantonId:form.canton,
            districtId: form.distrito,
            address: form.direccion,
            products: cart
          })
        });

        if (!response.ok) {
          setLoading(false);
          toastCheckoutError("No te preocupes, si tu dinero fue debitado contactate con nosotros al 8893-5779 y te ayudaremos a finalizar tu pedido. Error: " + response.text);
          return;
        }

        const data = await response.json();
        setLoading(false);
        clearCart();
        // 👉 Redirigir al componente de éxito con los datos
        navigate("/success", {
          state: {
            order: data.order,
            items: data.products,
            paymentMethod: paymentUsed,
            totalUSD: orderUSD,
            total: totalWithCommission
          },
        });
      }
      else
      {
        setLoading(false);
        toastCheckoutError("Fallo al realizar el pago." + order.status);
      }
    } catch (error) {
      setLoading(false);
      toastCheckoutError("No te preocupes, si tu dinero fue debitado contactate con nosotros al 8893-5779 y te ayudaremos a finalizar tu pedido. Error: " + error.message);
    }
  }

  const generateCode = (length = 8) => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  };

 const ononOrderConfirm = async (paymentMethod) => {
  setLoading(true);
  try {
    const paymentUsed = getPaymentUsed(paymentMethod);
    
      const response = await fetch("https://beadastra-a7epexf5c5b7dng0.canadacentral-01.azurewebsites.net/orders/create", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        orderId: generateCode(),
        customerName: form.nombre + " " + form.apellido,
        customerEmail: form.email,
        customerPhone: form.telefono,
        paymentMethod: paymentUsed,
        amount: totalWithCommission,
        amountUSD: orderUSD,
        stateId: form.provincia,
        cantonId: form.canton,
        districtId: form.distrito,
        address: form.direccion,
        products: cart,
      }),
    });

    if (!response.ok) {
      setLoading(false);
      toastCheckoutError("Escribenos al 8893-5779 y te ayudaremos a finalizar tu compra. Error: " + response.text);
      return;
    }

    const data = await response.json();
    setLoading(false);
    clearCart();
    // 👉 Redirigir al componente de éxito con los datos
    navigate("/success", {
      state: {
        order: data.order,
        items: data.products,
        paymentMethod: paymentUsed,
        totalUSD: orderUSD,
        total: totalWithCommission
      },
    });

  } catch (error) {
    setLoading(false);
    toastCheckoutError("Escribenos al 8893-5779 y te ayudaremos a finalizar tu compra. Error: " + error.message);
  }
};   



  return (
    
    <PayPalScriptProvider
      options={{
        clientId: "AT0u14aozgyuYYfQEvIr0i1nYB2BGP4ohf8hhmiPcC-dZXUa_QspU-rQYTbbovQiBN8pgSlhpZAQO2Cc",
        currency: "USD",
        components: "buttons",
        locale: "es_CR",
      }}
    >
      {loading && (
      <div className="fixed inset-0 bg-black/60 backdrop-blur-md flex flex-col items-center justify-center z-[9999]">

        {/* 🔥 Aura giratoria */}
        <div className="relative w-32 h-32 mb-6">
          <div className="absolute inset-0 rounded-full border-4 border-orange-500/30 animate-[spin-slow_4s_linear_infinite]"></div>

          {/* ✨ Brillo interno */}
          <div className="absolute inset-3 rounded-full bg-orange-400/10 blur-xl animate-[shimmer_2.5s_ease-in-out_infinite]"></div>

          {/* 🌟 Logo estrella AdAstra */}
          <img
            src="/adastraloader.png"  
            alt="AdAstra Logo"
            className="absolute inset-0 m-auto w-16 h-16 animate-[shimmer_2.5s_ease-in-out_infinite]"
          />
        </div>

        {/* Texto animado */}
        <p className="text-white text-lg font-semibold tracking-wide animate-[fadeUp_0.6s_ease-out]">
          Procesando tu pedido...
        </p>

      </div>
    )}
      <div ref={infoClienteRef} className="pt-24 pb-24 bg-gray-50 min-h-screen">
        <div className="max-w-5xl mx-auto px-5">
          <div className="grid py-6 grid-cols-1 md:grid-cols-2 gap-10">
            
            {/* FORMULARIO */}
            <div className="bg-white p-6 rounded-xl shadow">
              <h2 className="text-xl font-bold mb-4">Información del cliente</h2>
              <div  className="grid grid-cols-2 gap-4">

                {/* Nombre */}
                <div className="flex flex-col col-span-1">
                  <input
                    name="nombre"
                    placeholder="Nombre"
                    onChange={handleInput}
                    className={`border p-3 rounded w-full transition-all duration-150 ${
                      errors.nombre
                        ? "border-red-300 focus:border-red-400 focus:ring-red-100 bg-red-50/50"
                        : "border-gray-300 focus:border-black focus:ring-gray-200"
                    }`}
                  />
                  {errors.nombre && (
                    <p className="text-[11px] text-red-500 mt-1 pl-1 font-medium animate-fadeIn">
                      {errors.nombre}
                    </p>
                  )}
                </div>

                {/* Apellido */}
                <div className="flex flex-col col-span-1">
                  <input
                    name="apellido"
                    placeholder="Apellido"
                    onChange={handleInput}
                    className={`border p-3 rounded w-full transition-all duration-150 ${
                      errors.apellido
                        ? "border-red-300 focus:border-red-400 focus:ring-red-100 bg-red-50/50"
                        : "border-gray-300 focus:border-black focus:ring-gray-200"
                    }`}
                  />
                  {errors.apellido && (
                    <p className="text-[11px] text-red-500 mt-1 pl-1 font-medium animate-fadeIn">
                      {errors.apellido}
                    </p>
                  )}
                </div>

                {/* Teléfono */}
                <div className="flex flex-col col-span-2">
                  <input
                    name="telefono"
                    placeholder="Teléfono"
                    onChange={handleInput}
                    className={`border p-3 rounded w-full transition-all duration-150 ${
                      errors.telefono
                        ? "border-red-300 focus:border-red-400 focus:ring-red-100 bg-red-50/50"
                        : "border-gray-300 focus:border-black focus:ring-gray-200"
                    }`}
                  />
                  {errors.telefono && (
                    <p className="text-[11px] text-red-500 mt-1 pl-1 font-medium animate-fadeIn">
                      {errors.telefono}
                    </p>
                  )}
                </div>

                {/* Email */}
                <div className="flex flex-col col-span-2">
                  <input
                    name="email"
                    placeholder="Correo electrónico"
                    onChange={handleInput}
                    className={`border p-3 rounded w-full transition-all duration-150 ${
                      errors.email
                        ? "border-red-300 focus:border-red-400 focus:ring-red-100 bg-red-50/50"
                        : "border-gray-300 focus:border-black focus:ring-gray-200"
                    }`}
                  />
                  {errors.email && (
                    <p className="text-[11px] text-red-500 mt-1 pl-1 font-medium animate-fadeIn">
                      {errors.email}
                    </p>
                  )}
                </div>

              </div>


              <h2 className="text-xl font-bold mt-6 mb-4">Dirección de envío</h2>

              <div className="grid grid-cols-2 gap-4">
               {/* Provincia */}
              <div className="flex flex-col col-span-2">
                <SelectAdAstra
                  label="Provincia"
                  value={form.provincia}
                  onChange={(prov) => {
                  setForm({ ...form, provincia: prov, canton: "", distrito: "" });

                  // limpiar error
                  setErrors((err) => ({ ...err, provincia: "" }));

                  const cantonesOrdenados = Object.keys(ubicacionesCR[prov] || {}).sort();

                  setCantones(cantonesOrdenados);
                  setDistritos([]);
                }}
                  options={provincias}
                  error={errors.provincia}
                />
              </div>

              {/* Cantón */}
              <div className="flex flex-col col-span-2">
                <SelectAdAstra
                  label="Cantón"
                  value={form.canton}
                  onChange={(cant) => {
                  setForm({ ...form, canton: cant, distrito: "" });

                  // limpiar error
                  setErrors((err) => ({ ...err, canton: "" }));

                  const distritosOrdenados =
                    (ubicacionesCR[form.provincia]?.[cant] || []).sort();

                  setDistritos(distritosOrdenados);
                }}

                  options={cantones}
                  error={errors.canton}
                />
              </div>

              {/* Distrito */}
              <div className="flex flex-col col-span-2">
                <SelectAdAstra
                  label="Distrito"
                  value={form.distrito}
                  onChange={(v) => {
                    setForm({ ...form, distrito: v })
                    setErrors((err) => ({ ...err, distrito: "" }));
                  
                  }}
                  options={distritos}
                  error={errors.distrito}
                />
              </div>

                <div className="flex flex-col col-span-2">
                <textarea
                  name="direccion"
                  placeholder="Dirección exacta"
                  onChange={handleInput}
                  rows="3"
                  className={`border p-3 rounded w-full transition-all duration-150 ${
                    errors.direccion
                      ? "border-red-300 focus:border-red-400 focus:ring-red-100 bg-red-50/50"
                      : "border-gray-300 focus:border-black focus:ring-gray-200"
                  }`}
                />

                {errors.direccion && (
                  <p className="text-[11px] text-red-500 mt-1 pl-1 font-medium animate-fadeIn">
                    {errors.direccion}
                  </p>
                )}
              </div>

              </div>

              <h2 className="text-xl font-bold mt-6 mb-4">Método de pago</h2>

              {/* TARJETA */}
              <label
                className={`flex items-center justify-between p-3 border rounded-lg hover:border-black transition cursor-pointer ${
                  paymentMethod === "card" ? "border-black" : ""
                }`}
              >
                <div className="flex items-center gap-3">
                  <input
                    type="radio"
                    name="metodo"
                    checked={paymentMethod === "card"}
                    onChange={() => setPaymentMethod("card")}
                  />
                  <span className="font-medium text-gray-800 metodo-text">Con tarjeta (+6%)</span>
                </div>

              <div className="flex items-center gap-2 ml-4">
                  <div className="card-icon-box">
                    <img src="/cards/visa.svg" alt="Visa" />
                  </div>

                  <div className="card-icon-box">
                    <img src="/cards/mastercard.svg" alt="Mastercard" />
                  </div>

                  <div className="card-icon-box">
                    <img src="/cards/amex.svg" alt="Amex" />
                  </div>
                </div>


              </label>

              {/* BOTÓN TARJETA */}
              {paymentMethod === "card" && (
                <div className="p-4 border rounded-lg bg-gray-50 mt-2">
                  
                  <p className="text-xs text-center text-blue  animate-pulse font-medium">
                    Se cobrará una comisión del 6% establecida por la pasarela de pagos. Selecciona este botón para agregar los datos de tú tarjeta:
                  </p>
                  <PayPalButtons
                    fundingSource="card"
                    style={{ layout: "vertical" }}
                    createOrder={(data, actions) =>
                      guardedCreateOrder(() =>
                        actions.order.create({
                          purchase_units: [{ amount: { value: orderUSD } }],
                          application_context: { shipping_preference: "NO_SHIPPING" },
                        })
                      )
                    }
                    onApprove={async (data, actions) => {
                      const order = await actions.order.capture();
                      onPayPalSuccess(order);
                    }}
                    onError={(err) => console.log("Error: " + err.message)}
                  />
                     <div className="bg-white border rounded-lg p-3">
                   {(paymentMethod === "card" || paymentMethod === "paypal") && (
                      <div className="flex justify-between text-sm mt-1 text-gray-600">
                        <span>Subtotal</span>
                        <span>₡{Number(totalPrice).toLocaleString()}</span>
                      </div>
                    )}
                     {(paymentMethod === "card" || paymentMethod === "paypal") && (
                      <div className="flex justify-between text-sm mt-1 text-gray-600">                
                      <span>Envío</span>
                      {shippingCost === 0 ? (
                        <span>
                          <span className="line-through opacity-60 mr-1">₡2,500</span>
                          <span className="font-semibold text-green-600">GRATIS</span>
                        </span>
                      ) : (
                        <span>₡{Number(shippingCost).toLocaleString()}</span>
                      )}
                    </div>
                    )}
                    {(paymentMethod === "card" || paymentMethod === "paypal") && (
                      <div className="flex justify-between text-sm mt-1 text-gray-600">
                        <span>Comisión Pasarela de Pagos (6%):</span>
                        <span>₡{commissionAmount.toLocaleString()}</span>
                      </div>
                    )}
                  
                     {(paymentMethod === "card" || paymentMethod === "paypal") && (
                      <div className="flex justify-between text-lg font-bold">
                        <span>Total a pagar (Colones)</span>
                        <span>₡{totalWithCommission.toLocaleString()}</span>
                      </div>
                    )}
                     {(paymentMethod === "card" || paymentMethod === "paypal") &&  (
                      <p className="text-xs text-gray-500 mt-1 italic">
                        El cobro final se procesará en dólares. Conversión al tipo de cambio del día de hoy ₡{Math.ceil(USD_RATE)} = $1.
                      </p>        
                              
                    )}
                      
                     {(paymentMethod === "card" || paymentMethod === "paypal") && (
                      <div className="flex justify-between text-lg font-bold">
                        <span>Total a pagar (USD)</span>
                        <span>${orderUSD}</span>
                      </div>
                    )}
                    </div>
                    </div>
              )}

              {/* PAYPAL */}
              <label
                className={`flex items-center justify-between p-3 border rounded-lg hover:border-black transition cursor-pointer ${
                  paymentMethod === "paypal" ? "border-black" : ""
                }`}
              >
                <div className="flex items-center gap-3">
                  <input
                    type="radio"
                    name="metodo"
                    checked={paymentMethod === "paypal"}
                    onChange={() => setPaymentMethod("paypal")}
                  />
                  <span className="font-medium metodo-text">PayPal (+6%)</span>
                </div>
                <img src="https://upload.wikimedia.org/wikipedia/commons/b/b5/PayPal.svg" className="h-5 opacity-90" alt="PayPal" />
              </label>

              {paymentMethod === "paypal" && (
                <div className="p-4 border rounded-lg bg-gray-50 mt-2">
                  <p className="text-xs text-center text-blue animate-pulse font-medium">
                    Se cobrará una comisión del 6% establecida por PayPal. Selecciona este botón para iniciar sesión con tu cuenta:
                  </p>
                 <PayPalButtons
                  fundingSource="paypal"
                  style={{ layout: "vertical" }}
                   createOrder={(data, actions) =>
                      guardedCreateOrder(() =>
                        actions.order.create({
                          purchase_units: [{ amount: { value: orderUSD } }],
                          application_context: { shipping_preference: "NO_SHIPPING" },
                        })
                      )
                    }
                    onApprove={async (data, actions) => {
                      const order = await actions.order.capture();
                      onPayPalSuccess(order);
                    }}
                    onError={(err) => console.log("Error: " + err.message)}
                  />
                   
                  <div className="bg-white border rounded-lg p-3">
                     {(paymentMethod === "card" || paymentMethod === "paypal") && (
                      <div className="flex justify-between text-sm mt-1 text-gray-600">
                        <span>Subtotal</span>
                        <span>₡{Number(totalPrice).toLocaleString()}</span>
                      </div>
                    )}
                     {(paymentMethod === "card" || paymentMethod === "paypal") && (
                      <div className="flex justify-between text-sm mt-1 text-gray-600">                
                      <span>Envío</span>
                      {shippingCost === 0 ? (
                        <span>
                          <span className="line-through opacity-60 mr-1">₡2,500</span>
                          <span className="font-semibold text-green-600">GRATIS</span>
                        </span>
                      ) : (
                        <span>₡{Number(shippingCost).toLocaleString()}</span>
                      )}
                    </div>
                    )}
                    {(paymentMethod === "card" || paymentMethod === "paypal") && (
                      <div className="flex justify-between text-sm mt-1 text-gray-600">
                        <span>Comisión Pasarela de Pagos (6%):</span>
                        <span>₡{commissionAmount.toLocaleString()}</span>
                      </div>
                    )}
                  
                     {(paymentMethod === "card" || paymentMethod === "paypal") && (
                      <div className="flex justify-between text-lg font-bold">
                        <span>Total a pagar (Colones)</span>
                        <span>₡{totalWithCommission.toLocaleString()}</span>
                      </div>
                    )}
                     {(paymentMethod === "card" || paymentMethod === "paypal") &&  (
                      <p className="text-xs text-gray-500 mt-1 italic">
                        El cobro final se procesará en dólares. Conversión al tipo de cambio del día de hoy ₡{Math.ceil(USD_RATE)} = $1.
                      </p>        
                              
                    )}
                      
                     {(paymentMethod === "card" || paymentMethod === "paypal") && (
                      <div className="flex justify-between text-lg font-bold">
                        <span>Total a pagar (USD)</span>
                        <span>${orderUSD}</span>
                      </div>
                    )}
 </div> 

                </div>
              )}

               <label
                className={`flex items-center justify-between p-3 border rounded-lg hover:border-black transition cursor-pointer ${
                  paymentMethod === "sinpe" ? "border-black" : ""
                }`}
              >
                <div className="flex items-center gap-3">
                  <input
                    type="radio"
                    name="metodo"
                    checked={paymentMethod === "sinpe"}
                    onChange={() => setPaymentMethod("sinpe")}
                  />
                  <span className="font-medium metodo-text">SINPE Móvil (Sin comisión)</span>
                </div>
              </label>
              {/* 📌 Acordeón SINPE */}
              <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${
                  paymentMethod === "sinpe" ? "max-h-[500px] opacity-100 mt-2" : "max-h-0 opacity-0"
                }`}
              >
                <div className="p-4 border rounded-lg bg-gray-50 space-y-3">
                  <p className="text-gray-700 text-sm text-center">
                    Realiza el pago mediante <strong>SINPE Móvil</strong> al siguiente número:
                  </p>

                  <div className="bg-white border rounded-lg p-3">
                    <p className="text-gray-800 font-semibold text-lg">📱 8893-5779</p>
                    <p className="text-gray-500 text-sm">Nombre: <strong>Luis Stefano Quiros Ruiz</strong></p>
                    <div className="flex justify-between text-sm mt-1 text-gray-600">
                        <span>Subtotal</span>
                        <span>₡{Number(totalPrice).toLocaleString()}</span>
                      </div>
                      <div className="flex justify-between text-sm mt-1 text-gray-600">                
                      <span>Envío</span>
                      {shippingCost === 0 ? (
                        <span>
                          <span className="line-through opacity-60 mr-1">₡2,500</span>
                          <span className="font-semibold text-green-600">GRATIS</span>
                        </span>
                      ) : (
                        <span>₡{Number(shippingCost).toLocaleString()}</span>
                      )}
                    </div>
                    <div className="flex justify-between text-sm mt-1 text-gray-600">
                        <span>Sin Comisión</span>
                      </div>
                    <p className="text-gray-800 font-semibold text-lg">Total: ₡{totalWithCommission.toLocaleString()}</p>
                    
                  </div>

                  <p className="text-sm text-gray-600 text-center">
                    Una vez realizado el pago, <strong>envía el comprobante</strong> vía WhatsApp al mismo número y te estará llegando tu pedido a la dirección indicada entre 24 a 48 horas de recibido el pago.
                  </p>

                  <button
                    className="w-full bg-black text-white py-3 rounded-lg font-bold hover:bg-[#d24e1e] transition"
                    onClick={() => {
                      if (!validateForm()) return;
                      ononOrderConfirm('sinpe')
                    }}
                  >
                    CONFIRMAR PEDIDO
                  </button>
                </div>
              </div>
               <label
                className={`flex items-center justify-between p-3 border rounded-lg hover:border-black transition cursor-pointer ${
                  paymentMethod === "tb" ? "border-black" : ""
                }`}
              >
                <div className="flex items-center gap-3">
                  <input
                    type="radio"
                    name="metodo"
                    checked={paymentMethod === "tb"}  
                    onChange={() => setPaymentMethod("tb")}
                  />
                  <span className="font-medium metodo-text">Tranferencia Bancaria (Sin comisión)</span>
                </div>
              </label>
              <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${
                  paymentMethod === "tb" ? " opacity-100 mt-2" : "max-h-0 opacity-0"
                }`}
              >
                <div className="p-4 border rounded-lg bg-gray-50 space-y-3">
                  <div className="bg-white border rounded-lg p-3">
                    <div className="flex justify-between text-sm mt-1 text-gray-600">
                        <span>Subtotal</span>
                        <span>₡{Number(totalPrice).toLocaleString()}</span>
                      </div>
                      <div className="flex justify-between text-sm mt-1 text-gray-600">                
                      <span>Envío</span>
                      {shippingCost === 0 ? (
                        <span>
                          <span className="line-through opacity-60 mr-1">₡2,500</span>
                          <span className="font-semibold text-green-600">GRATIS</span>
                        </span>
                      ) : (
                        <span>₡{Number(shippingCost).toLocaleString()}</span>
                      )}
                    </div>
                    <div className="flex justify-between text-sm mt-1 text-gray-600">
                        <span>Sin Comisión</span>
                      </div>
                    <p className="text-gray-800 font-semibold text-lg">Total: ₡{totalWithCommission.toLocaleString()}</p>
                    
                  </div>
                   <p className="text-gray-700 text-sm text-center">
                    Realiza la <strong>Transferencia Bancaria</strong> a cualquiera de las siguientes cuentas:
                  </p>
                 <div>
                      <p className="font-semibold">🏦 BAC San José</p>
                      <p>Cuenta IBAN: <b>CR87010200009118287628</b></p>
                      <p>Nombre: <b>Luis Stefano Quiros Ruiz</b></p>
                    </div>

                    <div>
                      <p className="font-semibold">🏦 Banco Nacional</p>
                      <p>Cuenta IBAN: <b>CR25015116420010133154</b></p>
                      <p>Nombre: <b>Luis Stefano Quiros Ruiz</b></p>
                    </div>

                    <div>
                      <p className="font-semibold">🏦 Scotiabank</p>
                      <p>Cuenta IBAN: <b>CR16012300120125123004</b></p>
                      <p>Nombre: <b>Luis Stefano Quiros Ruiz</b></p>
                    </div>
                     <p className="text-sm text-gray-600 text-center">
                    Una vez realizado el pago, <strong>envía el comprobante</strong> vía WhatsApp al <strong>8893-5779</strong> y te estará llegando tu pedido a la dirección indicada entre 24 a 48 horas de recibido el pago.
                  </p>

                  <button
                    className="w-full bg-black text-white py-3 rounded-lg font-bold hover:bg-[#d24e1e] transition"
                    onClick={() => {
                       if (!validateForm()) return;
                       ononOrderConfirm('tb')
                      }}
                  >
                    CONFIRMAR PEDIDO
                  </button>
                </div>
              </div>
            </div>

            {/* RESUMEN */}
            <div className="bg-white p-6 rounded-xl shadow h-fit sticky top-28">
              <h2 className="text-xl font-bold mb-4">Resumen de tu pedido</h2>

              <div className="space-y-4">
                {cart.map((item) => (
                  <div key={item.id} className="flex gap-4 border-b pb-4">
                    <img src={item.image} className="w-20 h-20 object-cover rounded" alt=""/>
                    <div className="flex-1">
                      <p className="font-semibold text-gray-800">{item.pack} – {item.name}</p>
                      <div className="flex items-center gap-2 mt-2">

                      {/* Botón restar */}
                      <button
                        className="w-8 h-8 rounded-full border flex items-center justify-center hover:bg-gray-100"
                        onClick={() => updateQuantity(item.id, item.quantity - 1)}
                      >
                        −
                      </button>

                      {/* Cantidad */}
                      <span className="font-semibold w-6 text-center">
                        {item.quantity}
                      </span>

                      {/* Botón sumar */}
                      <button
                        className="w-8 h-8 rounded-full border flex items-center justify-center hover:bg-gray-100"
                        onClick={() => updateQuantity(item.id, item.quantity + 1)}
                      >
                        +
                      </button>

                      {/* Botón eliminar */}
                      <button
                        className="ml-auto text-xs text-red-500 hover:underline"
                        onClick={() => removeFromCart(item.id)}
                      >
                        Quitar
                      </button>

                    </div>

                      <p className="font-bold">₡{Number(item.total).toLocaleString()}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div className="mt-4 p-3 bg-gray-50 rounded-lg border">
              <p className="text-sm font-semibold text-gray-800 mb-2 text-center">
                ¿Tienes un código promocional?
              </p>

              <div className="flex gap-2">
                <input
                  value={promoCode}
                  onChange={(e) => setPromoCode(e.target.value)}
                  placeholder="Código Promocional"
                  className="flex-1 border rounded-lg px-3 py-2 text-sm"
                />
                <button
                  onClick={() => {
                    if (promoCode.trim().toLowerCase() === "byron") {
                      setPromoApplied(true);
                      toast.success("Código aplicado: 10% OFF", {
                      duration: 2500,
                      style: {
                        borderRadius: "10px",
                        background: "green",
                        color: "#fff",
                        fontWeight: "600",
                      },
                    });
                    } else {
                      setPromoApplied(false);
                      toast.error("Código inválido");
                    }
                  }}
                  className="bg-black text-white px-4 py-2 rounded-lg text-sm font-bold"
                >
                  Aplicar
                </button>
              </div>

              {promoApplied && (
                <p className="text-xs text-green-600 font-semibold mt-2">
                  ✔️ Descuento aplicado (10%)
                </p>
              )}
            </div>
              <div className="flex justify-between mt-4 text-gray-700">
                
                <span>Subtotal</span>
                  <span>
                    <span className="opacity-60 mr-1">₡{Number(totalPrice).toLocaleString()}</span>
                  </span>
              </div>
              {promoApplied && (
                <div className="flex justify-between mt-2 text-gray-700">
                  <span>Descuento (10%)</span>
                  <span className="text-green-600 font-semibold">
                    − ₡{promoDiscountAmount.toLocaleString()}
                  </span>
                </div>
              )}
              <div className="flex justify-between mt-4 text-gray-700">                
                <span>Envío</span>
                {shippingCost === 0 ? (
                  <span>
                    <span className="line-through opacity-60 mr-1">₡2,500</span>
                    <span className="font-semibold text-green-600">GRATIS</span>
                  </span>
                ) : (
                  <span>₡{Number(shippingCost).toLocaleString()}</span>
                )}
              </div>
              {(paymentMethod === "card" || paymentMethod === "paypal") && (
                      <div className="flex justify-between text-sm mt-1 text-gray-600">
                        <span>Comisión Pasarela de Pagos (6%):</span>
                        <span>₡{commissionAmount.toLocaleString()}</span>
                      </div>
                    )}

              <div className="mt-4">
                <div className="flex justify-between text-lg font-bold">
                  <span>Total a pagar</span>
                  <span>₡{(totalWithCommission).toLocaleString()}</span>
                </div>              
              </div>   
            </div>
          </div>
        </div>
      </div>
    </PayPalScriptProvider>
  );
}
